import { Input } from "@material-ui/core";
import classNames from "classnames";
import React, { Fragment, FunctionComponent } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import MaskedInput from "react-text-mask";

type OnChange = (e: { target: { name?: string; value: string } }) => void;

export interface TextMaskProps {
    inputRef: (instance: HTMLInputElement) => void;
    mask: Array<string | RegExp>;
    maskChar: string;
}

const TextMask: FunctionComponent<TextMaskProps> = ({ inputRef, mask, maskChar, ...other }) => {
    return (
        <MaskedInput
            {...other}
            mask={mask}
            placeholderChar={maskChar}
            ref={(ref: any) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            guide={false}
        />
    );
};

interface PostalCodeInputProps {
    className?: string;
    classNameLocation?: string;
    locationType?: string;
    mask: Array<string | RegExp> | ((value: string) => Array<string | RegExp>);
    maskChar: string;
    name?: string;
    onBlur?: (e: any) => void;
    onChange?: OnChange;
    onFocus?: () => void;
    placeholder?: string;
    type?: string;
    value?: any;
}

const PostalCodeInput: React.FunctionComponent<PostalCodeInputProps & WithTranslation> = ({
    className,
    classNameLocation,
    locationType,
    mask,
    maskChar,
    name = "zipCode",
    onBlur,
    onChange,
    onFocus,
    placeholder,
    t,
    type,
    value,
}) => {
    return (
        <Fragment>
            <Input
                className={classNames("PostalCode__input", className)}
                onBlur={onBlur}
                onChange={onChange}
                onFocus={onFocus}
                type={type}
                name={name}
                placeholder={placeholder}
                value={value}
                disableUnderline={true}
                inputComponent={TextMask as any}
                inputProps={{
                    mask,
                    maskChar,
                }}
            />
            {locationType === "dealer" && (
                <p className="PostalCode__explanation">
                    {t("CustomizePayment.ZipCode.PostalCodeInput.basedOnDealerExplanation")}
                </p>
            )}
        </Fragment>
    );
};

export default withTranslation()(PostalCodeInput);
